import { Url } from "@42.nl/react-url/lib";
import { DownOutlined, SettingOutlined } from "@ant-design/icons";
import { Dropdown, type MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useUser from "@hooks/user.hook";
import { CHAT_APP_URL } from "@src/app/chats/links";
import { FILTER_APP_URL } from "@src/app/filters/links";
import { IMPORT_APP_URL } from "@src/app/import/links";
import { JOB_APP_URL } from "@src/app/jobs/links";
import { LABEL_APP_URL } from "@src/app/labels/links";
import { PARAMETER_APP_URL } from "@src/app/parameters/links";
import { PERIOD_APP_URL } from "@src/app/periods/links";
import { REFERENCE_APP_URL } from "@src/app/references/links";
import { TAB_APP_URL } from "@src/app/tabs/utils/tabUrlUtils";
import { WIDGET_APP_URL } from "@src/app/widgets/links";
import { YEAR_APP_URL } from "@src/app/years/links";

type RawNavItem = {
  key: string;
  labelKey: string;
  path: Url;
};

export default function AdministrationNav() {
  const { t } = useTranslation(["topbar"]);

  const { isAdmin } = useUser();
  if (!isAdmin) {
    return <></>;
  }

  const rawItems: RawNavItem[] = [
    { key: "filters", labelKey: "TOPBAR.FILTERS", path: FILTER_APP_URL },
    { key: "labels", labelKey: "TOPBAR.LABELS", path: LABEL_APP_URL },
    {
      key: "parameters",
      labelKey: "TOPBAR.PARAMETERS",
      path: PARAMETER_APP_URL
    },
    {
      key: "references",
      labelKey: "TOPBAR.REFERENCES",
      path: REFERENCE_APP_URL
    },
    { key: "widgets", labelKey: "TOPBAR.WIDGETS", path: WIDGET_APP_URL },
    { key: "tabs", labelKey: "TOPBAR.TABS", path: TAB_APP_URL },
    { key: "import", labelKey: "TOPBAR.IMPORT", path: IMPORT_APP_URL },
    {
      key: "academic_years",
      labelKey: "TOPBAR.ACADEMIC_YEARS",
      path: YEAR_APP_URL
    },
    { key: "periods", labelKey: "TOPBAR.PERIODS", path: PERIOD_APP_URL },
    { key: "chats", labelKey: "TOPBAR.CHATS", path: CHAT_APP_URL },
    { key: "jobs", labelKey: "TOPBAR.JOBS", path: JOB_APP_URL }
  ];

  const menuItems: MenuProps["items"] = rawItems
    .map(({ key, labelKey, path }) => {
      const label = t(`topbar:${labelKey}`);
      return {
        key,
        label: <Link to={path}>{label}</Link>,
        sortLabel: label
      };
    })
    .sort((a, b) => a.sortLabel.localeCompare(b.sortLabel));

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={["click"]}
      className="nav-link"
    >
      <div className="sg-cursor-pointer sg-inline-flex sg-items-center sg-gap-2">
        <SettingOutlined aria-hidden={true} />
        <span>{t("TOPBAR.ADMINISTRATION")}</span>
        <DownOutlined className="sg-w-[12px] sg-h-[12px]" />
      </div>
    </Dropdown>
  );
}
